module.exports = __webpack_public_path__ + "icon-5.png?10fc3986c6d4be62c5f88ca0caa1111e";